<template>
  <div id="detailTable">
    <!--<div class="row alignRight">
      <div class="tableHeader noBorder">
        (Fees in EUR)
      </div>
    </div>-->
    <div class="row">
      <div class="leftCol">
        <div class="tableHeader alignCenter">
          Service Description
        </div>
      </div>
      <div class="rightCol">
        <div class="tableHeader alignCenter">
          Amount ({{ currency }})
        </div>
      </div>
    </div>

    <div class="row">
      <div class="leftCol">
        <div class="tableCell">
          Provision of Professional Services related to Leadership Development, Coaching,
          Consulting and/or Training to Hong Kong
          (as relevant project reference number(s) detailed below).
        </div>
      </div>
      <div class="rightCol">
        <div class="tableCell alignCenter"></div>
      </div>
    </div>

    <div
      v-for="(item, key) in invoice.engagements"
      :key="`eng${key}`"
      class="row transparentRow"
    >
      <div class="leftCol">
        <div class="tableCell">
          <ul>
            <li>
              {{ item.short_id }} ({{ item.invoice_ct }})
            </li>
          </ul>
        </div>
      </div>
      <div class="rightCol">
        <div class="tableCell alignCenter">
          <div>{{ item.amount }}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="leftCol">
        <div class="tableCell alignRight">
          Subtotal
        </div>
      </div>
      <div class="rightCol">
        <div class="tableCell alignCenter">
          {{ invoice.sub_total }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="leftCol">
        <div class="tableCell alignRight">
          Discount
        </div>
      </div>
      <div class="rightCol">
        <div class="tableCell alignCenter">
          {{ invoice.discount }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="leftCol">
        <div class="tableCell alignRight">
          VAT
        </div>
      </div>
      <div class="rightCol">
        <div class="tableCell alignCenter">
          {{ invoice.vat ? `${invoice.vat}%` : 'None' }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="leftCol">
        <div class="tableCell alignRight">
          Grand Total
        </div>
      </div>
      <div class="rightCol">
        <div class="tableCell alignCenter">
          {{ currencySymbol }} {{ invoice.grand_total }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invoice: {
      type: Object,
      default: null,
    },
  },

  computed: {
    currency() {
      return process.env.VUE_APP_CURRENCY_SHORT || 'USD';
    },

    currencySymbol() {
      return process.env.VUE_APP_CURRENCY_SYMBOL || '$';
    },
  },
};
</script>

<style lang="scss" scoped>
  #detailTable {
    border-left: 1px solid #212121;
    border-right: 1px solid #212121;
    padding: 0 !important;
    word-break: break-word;
    white-space: normal;

    .row {
      display: flex;
      border-top: 1px solid #606266;

      .tableHeader {
        padding: 10px 25px;

        &.noBorder {
          border: none;
        }
      }

      .leftCol {
        width: 70%;
        border-right: 1px solid #606266;
      }

      .rightCol {
        width: 30%;
      }

      .tableCell {
        width: 100%;
        height: 100%;
        padding: 10px;
        box-sizing: border-box;
      }

      &:last-child {
        border-bottom: 1px solid #606266;
      }

      &.transparentRow {
        border: none;

        .tableCell {
          padding: 4px 10px;

          ul {
            margin: 0;
            padding: 0 0 0 20px;
          }
        }
      }
    }

    .alignRight {
      text-align: right;
      justify-content: flex-end;
    }

    .alignCenter {
      text-align: center;
      justify-content: center;
    }
  }
</style>
